<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button text="" [routerLink]="'/settings'" />
    </ion-buttons>
    <ion-title>{{ 'SETTINGS.TARGET_GROUP' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-list>
    <ion-radio-group (ionChange)="setTargetGroup($event)" [value]="targetGroup()">
      <ion-item>
        <ion-radio [translate]="'INTRO.PRE_EXISTING'" justify="start" label-placement="end" value="pre-existing" />
      </ion-item>
      <ion-item>
        <ion-radio [translate]="'INTRO.GESTATIONAL'" justify="start" label-placement="end" value="gestational" />
      </ion-item>
    </ion-radio-group>
  </ion-list>
</ion-content>
